import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 8,
});

export default StyledBox;
